module.exports = __webpack_public_path__ + "2f22989da8653e02e69c7fbebfe462e4.jpg";